/**
 * After a submit that failed its checks, moves focus to the first field the form marked invalid,
 * so a keyboard or screen reader user lands on what to fix and hears its error:
 *
 *   onSubmit={(event) => {
 *     event.preventDefault();
 *     if (!valid) focusFirstError(event.currentTarget);
 *   }}
 *
 * It waits a frame because the errors, and the `aria-invalid` it looks for, are drawn by the render
 * the failed submit causes, after the handler returns.
 */
export function focusFirstError(form: HTMLFormElement): void {
  window.requestAnimationFrame(() => {
    form
      .querySelector<HTMLElement>(
        "[aria-invalid='true']:is(input, select, textarea), fieldset[aria-invalid='true'] input",
      )
      ?.focus();
  });
}
